import createIcon from '../../createIcon';

/**
 * @component @name ModeNight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDJDNy42OCAyIDUuOTcgMi41IDQuNSAzLjM1QzcuNDkgNS4wOCA5LjUgOC4zIDkuNSAxMkM5LjUgMTUuNyA3LjQ5IDE4LjkyIDQuNSAyMC42NUM1Ljk3IDIxLjUgNy42OCAyMiA5LjUgMjJDMTUuMDIgMjIgMTkuNSAxNy41MiAxOS41IDEyQzE5LjUgNi40OCAxNS4wMiAyIDkuNSAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeNight = createIcon('ModeNight', [
  [
    'path',
    {
      d: 'M9.5 2C7.68 2 5.97 2.5 4.5 3.35C7.49 5.08 9.5 8.3 9.5 12C9.5 15.7 7.49 18.92 4.5 20.65C5.97 21.5 7.68 22 9.5 22C15.02 22 19.5 17.52 19.5 12C19.5 6.48 15.02 2 9.5 2Z',
      key: '1xvms6',
    },
  ],
]);

export default ModeNight;
